import axios from "axios";

export async function requestRefreshToken(token) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/auth/refresh`, {
		token,
	});
}

export async function requestGetProfile() {
	return await axios.get(`${import.meta.env.VITE_API_URL}/users/me`);
}

export async function requestGetAddressList() {
	return await axios.get(`${import.meta.env.VITE_API_URL}/users/me/addresses`);
}

export async function requestAddAddress(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/users/me/addresses/add`, payload);
}

export async function requestUpdateAddress(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/users/me/addresses/${id}/edit`, payload);
}

export async function requestDeleteAddress(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/users/me/addresses/${id}/delete`);
}

export async function requestGetNotificationList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/notifications?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}

export async function requestReadAllNotification() {
	return await axios.post(`${import.meta.env.VITE_API_URL}/notifications/read`);
}

export async function requestReadNotification(id) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/notifications/${id}/read`);
}

// STATISTIC START
export async function requestGetStatistics(teamId) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/${teamId}/statistics`);
}
// STATISTIC END

// SERVICE START
export async function requestGetServiceGroupList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/service-groups?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}

export async function requestGetServiceList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/services?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}
// SERVICE END

// DOMAIN-EXTENSION START
export async function requestGetDomainExtensionList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/domain-extensions?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}
// DOMAIN-EXTENSION END

// ORDER START
export async function requestCreateOrder(teamId, payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/${teamId}/orders/add`, payload);
}
// ORDER END

// INVOICE START
export async function requestGetInvoiceList(
	teamId,
	{ page = 1, limit = 10, order = "_id:desc", keyword = "", filter = "" }
) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/${teamId}/invoices?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}

export async function requestShowInvoice(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/${teamId}/invoices/${id}`);
}

export async function requestPayInvoice(teamId, id, payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/${teamId}/invoices/${id}/pay`, payload);
}
// INVOICE END

// TRANSACTION START
export async function requestGetTransactionList(
	teamId,
	{ page = 1, limit = 10, order = "_id:desc", keyword = "", filter = "" }
) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/${teamId}/transactions?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}
// TRANSACTION END

// INSTANCE START
export async function requestGetInstanceList(
	teamId,
	{ page = 1, limit = 10, order = "_id:desc", keyword = "", filter = "" }
) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/${teamId}/instances?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}

export async function requestShowInstance(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/${teamId}/instances/${id}`);
}
// INSTANCE END

// DOMAIN START
export async function requestGetDomainList(
	teamId,
	{ page = 1, limit = 10, order = "_id:desc", keyword = "", filter = "" }
) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/${teamId}/domains?order=${order}&page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}`
	);
}

export async function requestShowDomain(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/${teamId}/domains/${id}`);
}
// DOMAIN END

// WEHO SERVER ACCOUNT START
export async function requestShowWEHOAccountDetails(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/@weho/${teamId}/accounts/${id}`);
}
// WEHO SERVER ACCOUNT END

// DOMA START
export async function requestCheckDomaDomainAvailability(domain) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/@doma/domains/check`, { domain });
}

export async function requestCheckDomaDomainWhois(domain) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/@doma/domains/whois`, { domain });
}
// DOMA END

// GHUB START
export async function requestGetGhubRepositories(teamId) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/@ghub/${teamId}/repositories`);
}

export async function requireGetGhubRepositoryBranches(teamId, repositoryId) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/@ghub/${teamId}/repositories/${repositoryId}/branches`
	);
}
// GHUB END

// PAYMENT START
export async function requestGetPaymentList(amount, method) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/payments?amount=${amount}&m=${method}`);
}
// PAYMENT END
